import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Detail_Textual_PBar({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Find the hit range to display on the right
  const hitRange = item.scale.ranges.find((range) => range.isHit);

  return (
    <Row className={"mb-4 mx-0"}>
      <div className="p-3" style={{ border: "1px solid #e0e0e0", borderRadius: "8px", backgroundColor: "#fff" }}>
        {/* Main layout */}
        <Row className="align-items-stretch" style={{ flexWrap: "nowrap" }}>
          <Col
            xs={2}
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ minWidth: "150px", maxWidth: "150px" }}
          >
            {item.isSub && item.scopeName && (
              <div className="detail-section-sub-scope-name-header-wrap-up" style={{ fontSize: "14px", color: "#666" }}>
                {item.scopeName}
              </div>
            )}
            {/* Scope name above progress bar */}
            <div
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#333",
                marginBottom: "10px",
                textAlign: "center",
              }}
            >
              {item.name}
            </div>
          </Col>

          {/* Center - Horizontal Progress Bar */}
          <Col
            style={{ width: "250px", minWidth: "250px", maxWidth: "250px", padding: "0" }}
            className="d-flex flex-column justify-content-center align-items-center"
          >
            <Row className={"mx-0 w-100"}>
              <Col xs={"auto"} className={"align-content-center px-0"}>
                <div className={"fw-medium lh-1 text-color-gray-dark"} style={{ fontSize: "20px" }}>
                  {elementScore}%
                </div>
              </Col>
              <Col className={"px-2"}>
                <div
                  style={{
                    borderRadius: "13px",
                    background: "linear-gradient(270deg, rgba(160, 228, 234, 0.2) 0%, rgba(0, 234, 255, 0.2) 100%)",
                  }}
                >
                  <Row className={"mx-0"} style={{ height: "26px" }}>
                    <Col
                      xs={"auto"}
                      className={"px-0"}
                      style={{
                        borderRadius: "13px",
                        minWidth: "26px",
                        width: `${elementScore}%`,
                        background: "linear-gradient(270deg, #A0E4EA 0%, #00EAFF 100%)",
                      }}
                    ></Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>

          {/* Right side - Hit range text */}
          <Col className="pe-4 d-flex flex-column justify-content-center" style={{ flex: "1" }}>
            {hitRange && (
              <div className="detail-textual-content-box">
                {item.scale.isHtml ? <div dangerouslySetInnerHTML={{ __html: hitRange.text }} /> : hitRange.text}
              </div>
            )}
          </Col>
        </Row>
      </div>
    </Row>
  );
}
